import { createContext, useState } from "react";

const VideoContext = createContext({});

export const VideoProvider = ({ children }) => {
  const [videoFeed, setVideoFeed] = useState(null);

  return (
    <VideoContext.Provider value={{ videoFeed, setVideoFeed }}>
      {children}
    </VideoContext.Provider>
  );
};

export default VideoContext;
